import { render, staticRenderFns } from "./OffersViewer.vue?vue&type=template&id=ca4e737e&"
import script from "./OffersViewer.vue?vue&type=script&lang=js&"
export * from "./OffersViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports